import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  allCountries: [],
  infoBoxes: [],
  birthDate: {
    isValid: false,
    isUnderAgeDialogOpen: false,
  },
  invalid: {
    isInvalidOpen: false,
    message: "",
  },
  delete: {
    isDeleteOpen: false,
    projectId: null,
  },
  popup: {
    isOpen: false,
  },
  notFound: {
    isOpen: false,
    heading: "",
    body: "",
  },
  tabName: "",
};

const infoSlice = createSlice({
  name: "info",
  initialState,
  reducers: {
    setAllCountries: (state, action) => {
      state.allCountries = action.payload;
    },
    setInfoBoxes: (state, action) => {
      state.infoBoxes = action.payload;
    },
    updateBirthDate: (state, action) => {
      state.birthDate = { ...state.birthDate, ...action.payload };
    },
    updateInvalid: (state, action) => {
      state.invalid = { ...state.invalid, ...action.payload };
    },
    updateDelete: (state, action) => {
      state.delete = { ...state.delete, ...action.payload };
    },
    updatePopup: (state, action) => {
      state.popup = { ...state.popup, ...action.payload };
    },
    updateNotFound: (state, action) => {
      state.notFound = { ...state.notFound, ...action.payload };
    },
    setTabName: (state, action) => {
      state.tabName = action.payload;
    },
  },
});

export const {
  setAllCountries,
  setInfoBoxes,
  updateBirthDate,
  updateInvalid,
  updateDelete,
  updatePopup,
  updateNotFound,
  setTabName,
} = infoSlice.actions;
export default infoSlice.reducer;
